package io.horion.auth.api.models.response

import kotlinx.serialization.Serializable

@Serializable
sealed class AuthResponse {
    @Serializable
    data class Success(
        val token: Token? = null,
        val refreshToken: String? = null,
        val code: String? = null
    ): AuthResponse()

    @Serializable
    data class Error(
        val message: String
    ): AuthResponse()
}
